/* Progressive enhancements; Shopify's existing filters and product forms stay in use. */
(() => {
  // Older product templates link to ?q=vendor:slug; Shopify collections require filter.p.vendor.
  // Resolve against Shopify's rendered vendor values so multiword brands keep their real spelling.
  const currentUrl = new URL(window.location.href);
  const legacyVendor = /^vendor:(.+)$/i.exec(currentUrl.searchParams.get('q') || '');
  if (legacyVendor) {
    const toSlug = (value) => value.trim().toLowerCase().normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const requestedSlug = toSlug(legacyVendor[1]);
    const vendors = Array.from(document.querySelectorAll('input[name="filter.p.vendor"]'), input => input.value);
    const vendor = vendors.find(value => toSlug(value) === requestedSlug) || legacyVendor[1].replace(/-/g, ' ').trim();
    currentUrl.searchParams.delete('q');
    currentUrl.searchParams.delete('page');
    if (!currentUrl.searchParams.has('filter.p.vendor')) currentUrl.searchParams.set('filter.p.vendor', vendor);
    window.location.replace(currentUrl.href);
    return;
  }

  // Manufacturer headings sit outside the theme's AJAX result fragment. Refresh when
  // the selected manufacturer changes so the heading never describes stale results.
  if (document.querySelector('[data-ac-brand-page]')) {
    const vendorKey = () => new URL(window.location.href).searchParams.getAll('filter.p.vendor').sort().join('\u0000');
    const initialVendorKey = vendorKey();
    const listing = document.querySelector('#kt--filter-js');
    if (listing) {
      const observer = new MutationObserver(() => {
        if (vendorKey() === initialVendorKey) return;
        observer.disconnect();
        const resultsUrl = new URL(window.location.href);
        resultsUrl.hash = 'ac-product-results';
        window.location.replace(resultsUrl.href);
      });
      observer.observe(listing, { childList: true, subtree: true });
    }
  }
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-ac-sort]')) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    url.hash = 'ac-product-results';
    window.location.assign(url.href);
  });
  document.addEventListener('keydown', (event) => {
    if (!event.target.matches('.accessories-modern .filterMobile')) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      event.target.click();
    }
  });
  const resultsLinks = '.ac-categories a, .brand-navigation-carousel__item, .charging-brand-carousel__item, .logo-container .logo-list a';
  const linkToResults = link => {
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || !url.pathname.startsWith('/collections/')) return;
    url.hash = 'ac-product-results';
    link.href = url.href;
  };
  document.addEventListener('click', event => {
    const link = event.target.closest(resultsLinks);
    if (link && document.body.classList.contains('accessories-modern')) linkToResults(link);
  }, true);
  const enhance = () => {
    if (document.body.classList.contains('accessories-modern')) document.querySelectorAll(resultsLinks).forEach(linkToResults);
    const close = document.querySelector('.accessories-modern .kt--filter-m .headFilter button.close');
    if (close) close.setAttribute('aria-label', 'Produktfilter schließen');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance);
  else enhance();
})();

// Persistent, draggable filter scrollbars; the original filter lists remain scrollable.
(() => {
  const init = () => {
    const rails = new Map();
    let nextId = 0;
    const resize = new ResizeObserver(() => rails.forEach(item => item.update()));
    const enhance = () => {
      document.querySelectorAll('.accessories-modern .kt--filter-m .headFilter button.close').forEach(close => close.setAttribute('aria-label', 'Produktfilter schließen'));
      rails.forEach((item, list) => {
        if (!list.isConnected) { resize.unobserve(list); item.rail.remove(); rails.delete(list); }
      });
      document.querySelectorAll('.accessories-modern .kt--filter-gr-i_ul').forEach(list => {
        if (rails.has(list)) { rails.get(list).update(); return; }
        const parent = list.parentElement;
        // The theme clones filters for its mobile drawer; discard copied rails.
        parent.querySelectorAll(':scope > .ac-filter-scrollbar').forEach(copy => copy.remove());
        const rail = document.createElement('div');
        const thumb = document.createElement('span');
        rail.className = 'ac-filter-scrollbar';
        thumb.className = 'ac-filter-scrollbar__thumb';
        rail.append(thumb);
        rail.setAttribute('role', 'scrollbar');
        rail.setAttribute('aria-orientation', 'vertical');
        rail.setAttribute('aria-label', (parent.querySelector('.layered_subtitle')?.textContent.trim() || 'Filter') + ' – weitere Optionen');
        rail.setAttribute('aria-valuemin', '0');
        rail.tabIndex = 0;
        if (!list.id || list.id.startsWith('ac-filter-scroll-list-')) list.id = 'ac-filter-scroll-list-' + (++nextId);
        rail.setAttribute('aria-controls', list.id);
        parent.classList.add('ac-filter-scroll-parent');
        list.classList.add('ac-filter-scroll-list');
        parent.append(rail);
        let travel = 0;
        const update = () => {
          const max = Math.max(0, list.scrollHeight - list.clientHeight);
          rail.hidden = list.clientHeight === 0 || max <= 1;
          if (rail.hidden) return;
          const listRect = list.getBoundingClientRect();
          const parentRect = parent.getBoundingClientRect();
          const height = list.clientHeight;
          const thumbHeight = Math.min(height, Math.max(28, height * height / list.scrollHeight));
          travel = height - thumbHeight;
          rail.style.top = (listRect.top - parentRect.top - parent.clientTop + parent.scrollTop) + 'px';
          rail.style.height = height + 'px';
          thumb.style.height = thumbHeight + 'px';
          const position = Math.max(0, Math.min(max, list.scrollTop));
          thumb.style.transform = 'translateY(' + (travel * position / max) + 'px)';
          rail.setAttribute('aria-valuemax', String(Math.round(max)));
          rail.setAttribute('aria-valuenow', String(Math.round(position)));
        };
        let offset = 0;
        const move = event => {
          const max = list.scrollHeight - list.clientHeight;
          const top = event.clientY - rail.getBoundingClientRect().top - offset;
          list.scrollTop = travel > 0 ? Math.max(0, Math.min(1, top / travel)) * max : 0;
        };
        rail.addEventListener('pointerdown', event => {
          if (event.button !== 0) return;
          event.preventDefault();
          const rect = thumb.getBoundingClientRect();
          offset = event.clientY >= rect.top && event.clientY <= rect.bottom ? event.clientY - rect.top : rect.height / 2;
          rail.setPointerCapture(event.pointerId);
          move(event);
        });
        rail.addEventListener('pointermove', event => { if (rail.hasPointerCapture(event.pointerId)) move(event); });
        rail.addEventListener('pointerup', event => { if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId); });
        rail.addEventListener('keydown', event => {
          const values = { ArrowDown: list.scrollTop + 40, ArrowUp: list.scrollTop - 40, PageDown: list.scrollTop + list.clientHeight, PageUp: list.scrollTop - list.clientHeight, Home: 0, End: list.scrollHeight };
          if (!(event.key in values)) return;
          event.preventDefault();
          list.scrollTop = values[event.key];
        });
        list.addEventListener('scroll', update, { passive: true });
        rails.set(list, { rail, update });
        resize.observe(list);
        update();
      });
    };
    enhance();
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('.kt--filter-gr-i_ul') || node.querySelector('.kt--filter-gr-i_ul'))))) enhance();
    }).observe(document.querySelector('#PageContainer') || document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
